export const state = {
    teamStep1: {
        owner_email: "",
        invite_emails: [],
        owner_has_seat: false,
    },
    teamStep2: {
        owner_email: "",
        token: "",
        password: "",
        full_name: "",
        country_id: null,
        zip: "",
        terms: false,
        client_secret: null, /* 3D Secure */
    },
    isLoggedIn: false,
};
